export default "__VITE_ASSET__D8UPhj8s__"